import React, { useState } from 'react';
import api from "../api";

function UploadJson() {
  const [files, setFiles] = useState([]);

  const handleFileChange = (event) => {
    setFiles(event.target.files);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (files.length === 0) {
      alert('Please select at least one file!');
      return;
    }

    const formData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append('files', files[i]);
    }

    try {
      const response = await api.post('/api/insert_content', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      alert('Upload successful!');
      console.log(response.data);
      setFiles([]);
      event.target.reset();
    } catch (error) {
      console.error('Error:', error);
      alert('Error uploading files!');
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <input type="file" onChange={handleFileChange} accept=".json" multiple />
      <button type="submit">Upload JSON Files</button>
    </form>
  );
}

export default UploadJson;